var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var _excluded = ["className", "type"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
__name(_objectWithoutProperties, "_objectWithoutProperties");
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
__name(_objectWithoutPropertiesLoose, "_objectWithoutPropertiesLoose");
import classNames from "classnames";
import React, { Fragment } from "react";
import { MenuItem, TYPE as MENU_ITEM_TYPE, TYPE_TO_CLASSNAME } from "../item/Item";
import { MenuListTitle } from "./Title";
import { menuListCls, menuListBorderCls, menuListItemCls, menuListItemWithImgCls } from "./List.less";
var MenuList = /* @__PURE__ */ __name(function MenuList2(_ref) {
  var _ref$border = _ref.border, border = _ref$border === void 0 ? false : _ref$border, _ref$titleProps = _ref.titleProps, titleProps = _ref$titleProps === void 0 ? null : _ref$titleProps, items = _ref.items, className = _ref.className, opened = _ref.opened;
  return /* @__PURE__ */ React.createElement(Fragment, null, titleProps ? /* @__PURE__ */ React.createElement(MenuListTitle, titleProps || {}) : null, /* @__PURE__ */ React.createElement("ul", {
    className: classNames(menuListCls, border && menuListBorderCls, className)
  }, items.map(function(_ref2, idx) {
    var itemClassName = _ref2.className, type = _ref2.type, linkProps = _objectWithoutProperties(_ref2, _excluded);
    return /* @__PURE__ */ React.createElement("li", {
      key: idx,
      className: classNames(menuListItemCls, TYPE_TO_CLASSNAME[type || MENU_ITEM_TYPE.LINK], linkProps.image && menuListItemWithImgCls, itemClassName)
    }, /* @__PURE__ */ React.createElement(MenuItem, _extends({
      type
    }, linkProps, {
      opened
    })));
  })));
}, "MenuList");
export {
  MenuList
};
